module.exports = __webpack_public_path__ + "img/icone-selo-first-position.5c29b312.svg";